import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

/* Layout */
import Layout from '@/view/layout/LayoutIndex'

export default new Router({
	routes: [
		{ path: '/', name: 'base', redirect: '/notice' },
		// 重定向页面路由
		{
			path: '/redirect',
			name: 'redirect',
			component: resolve => require(['@/view/redirect/RedirectIndex'], resolve),
			isHidden: 1,
			children: [
				{
					path: '/redirect/:path*',
					component: resolve => require(['@/view/redirect/RedirectIndex'], resolve)
				}
			]
		},

		// 营销页首页
		{
			path: '/home',
			component: Layout,
			// redirect: '/home/index',
			redirect: '/notice',
			children: [
				{
					path: 'index',
					redirect: '/notice',
					component: resolve => require(['@/view/home'], resolve),
					name: 'home',
					meta: { title: '首页' }
				}
			]
		},

		{
			path: '/notice',
			component: Layout,
			redirect: '/notice/index',
			children: [
				{
					path: 'index',
					component: resolve => require(['@/view/notice/index'], resolve),
					name: '资讯公告',
					meta: { title: '资讯公告' }
				}
			]
		},

		{
			path: '/help',
			component: Layout,
			redirect: '/help/index',
			children: [
				{
					path: 'index',
					component: resolve => require(['@/view/help'], resolve),
					name: 'help',
					meta: { title: '帮助中心' }
				}
			]
		},

		{
			path: '/login',
			name: 'login',
			meta: {
				title: '登录'
			},
			component: resolve => require(['@/view/login'], resolve)
		},

		{
			path: '/register',
			name: 'register',
			meta: {
				title: '注册'
			},
			component: resolve => require(['@/view/register'], resolve)
		},

		{
			path: '/password',
			name: 'password',
			meta: {
				title: '密码重置'
			},
			component: resolve => require(['@/view/password'], resolve)
		},
		{
			path: '/bind-phone',
			name: 'Bind-phone',
			meta: {
				title: '绑定手机号'
			},
			component: resolve => require(['@/view/bind-phone'], resolve)
		},

		{
			path: '/bridge',
			name: 'bridge',
			meta: {
				title: '跳转'
			},
			component: resolve => require(['@/view/bridge'], resolve)
		},
		{
			path: '/preview-online',
			name: 'preview-online',
			hidden: true,
			meta: {
				title: '文件预览'
			},
			component: () => import('../components/bm-preview/preview-online.vue')
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js